import { useTranslation } from 'next-i18next'
import { useId, useState } from 'react'

import StartAnalytics from '~/analytics/start/startAnalytics'
import { FaqItemData } from '~/landingV4/types/faq.types'

type Props = FaqItemData

export default function FaqItem({ answerKey, defaultExpanded = false, questionKey }: Props): React.ReactElement {
  const { t } = useTranslation('abTestLanding')
  const [isExpanded, setIsExpanded] = useState(defaultExpanded)
  const panelId = useId()

  const handleToggle = (): void => {
    setIsExpanded((prev) => !prev)
    StartAnalytics.logButtonClick(t(questionKey))
  }

  return (
    <div className="w-full overflow-hidden rounded-4 border border-black/10 bg-white shadow-sm">
      <button
        aria-controls={panelId}
        aria-expanded={isExpanded}
        className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
        onClick={handleToggle}
        type="button"
      >
        <span className="text-sm font-semibold text-black-ink">{t(questionKey)}</span>
        <span aria-hidden className="text-5 font-medium leading-none text-purple" data-test-id="faq-toggle-icon">
          {isExpanded ? '−' : '+'}
        </span>
      </button>
      {isExpanded && (
        <div className="border-t border-black/5 px-6 pb-5 pt-4" id={panelId}>
          <p className="text-sm leading-normal text-purple-muted-violet">{t(answerKey)}</p>
        </div>
      )}
    </div>
  )
}
